import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './EyeIcon.c.svg';

export const EyeIcon = withIconWrapper(ReactComponent);
